const invalidNumberKeys = ["-", "+", "e", "E"];

const isNumberInput = (element) =>
  element && element.tagName === "INPUT" && element.type === "number";

const setMinimumValue = (element) => {
  if (isNumberInput(element)) element.min = "0";

  if (element.querySelectorAll) {
    element.querySelectorAll('input[type="number"]').forEach((input) => {
      input.min = "0";
    });
  }
};

export const initializeNumberInputValidation = () => {
  setMinimumValue(document);

  document.addEventListener("focusin", (event) => {
    if (isNumberInput(event.target)) event.target.min = "0";
  });

  document.addEventListener(
    "keydown",
    (event) => {
      if (
        isNumberInput(event.target) &&
        invalidNumberKeys.includes(event.key)
      ) {
        event.preventDefault();
      }
    },
    true,
  );

  document.addEventListener(
    "input",
    (event) => {
      if (isNumberInput(event.target) && Number(event.target.value) < 0) {
        event.target.value = "0";
      }
    },
    true,
  );

  document.addEventListener(
    "paste",
    (event) => {
      if (!isNumberInput(event.target)) return;

      const pastedValue = event.clipboardData.getData("text").trim();
      if (!/^\d*\.?\d*$/.test(pastedValue)) event.preventDefault();
    },
    true,
  );
};
